import React from 'react';

const SobreNatacha = () => {
  return (
    <section id="natacha" className="section section-suave">
      <div className="container">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div className="image-organic max-w-md mx-auto md:mx-0">
            <img
              src="/natacha.jpg"
              alt="Natacha González, nutricionista y fundadora de Nútrete"
              width="1101"
              height="1429"
              loading="lazy"
              decoding="async"
            />
          </div>

          <div>
            <h2 className="heading-2 mb-6">
              Quién está detrás de <em>Nútrete</em>
            </h2>
            <p className="body-large">
              Soy Natacha González, nutricionista y fundadora de Nútrete EIRL.
              Después de años trabajando en alimentación y bienestar
              organizacional, creé Nútrete para ofrecer algo que no encontraba
              en el mercado: una mirada que combina rigor técnico con
              herramientas complementarias como la fitoterapia y la
              aromaterapia, pensando siempre en las personas detrás de cada
              organización.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SobreNatacha;
